import { motion, useTransform } from "framer-motion";
import { useNavigate } from "react-router-dom";
import logo from "../assets/iconOnly.png";

export default function AboutUs({ scrollY }) {

    const h = window.innerHeight
    const navigate = useNavigate()
    const m = window.innerWidth < 768;
  
    const x = useTransform(scrollY, [0, h - 100, h], [ -130, 0, (m ? 0 : 50)], {
        clamp: false
    })

    const opacity = useTransform(scrollY, [0, h - 100, h], [0, (m ? 1 : 0.5), 1], {
        clamp: false
    })

    
    return (
        <>
            <motion.div id="about-us" style={{ position: 'relative'}} className="flex centerX">
                <motion.div className="content"
                    style={{
                        x: x,
                        opacity: opacity
                    }}
                    transition={{
                        duration: 0.8
                    }}
                >
                    <h1 style={{ fontSize: m ? 50 : 40 }} >{m ? "" : "Empowering Businesses through "}Innovative Software Solutions</h1>
                    <p>
                    P&S Tech Solutions is a leading software company specializing in providing innovative solutions for businesses.
                    </p>
                    <br />
                    <div>
                        <button onClick={() => navigate("/about-us")} style={{ backgroundColor: "#000", color: "#fff"}}>Learn More</button>
                    </div>
                </motion.div>
                <motion.img
                    alt="logo-design"
                    src={logo}
                    style={{
                        position: 'absolute',
                        right: 50,
                        "-webkit-filter": `brightness(0) invert(0)`,
                        filter: `brightness(0) invert(0)`,
                        x,
                        opacity
                    }} 
                    transition={{
                        duration: 0.8
                    }}
                />
            </motion.div>
        </>
    )
}